import { render, staticRenderFns } from "./BoRegistrationCancelModal.vue?vue&type=template&id=f1ffbb76&scoped=true"
import script from "./BoRegistrationCancelModal.vue?vue&type=script&lang=js"
export * from "./BoRegistrationCancelModal.vue?vue&type=script&lang=js"
import style0 from "./BoRegistrationCancelModal.vue?vue&type=style&index=0&id=f1ffbb76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ffbb76",
  null
  
)

export default component.exports